document.addEventListener("DOMContentLoaded", () => {
  const topbar = document.querySelector(".header__topbar");
  const menuHeader = document.querySelector(".menu-header-mobile");

  if (!topbar || !menuHeader) return;

  // observer for banner and scroll lock on mobile menu
  const observer = new MutationObserver(() => {
    const isOpen = menuHeader.classList.contains("open");

    topbar.style.display = isOpen ? "none" : "block";
    document.body.style.overflow = isOpen ? "hidden" : "auto";
  });

  observer.observe(menuHeader, {
    attributes: true,
    attributeFilter: ["class"],
  });

  // submenu toggle buttons
  document.addEventListener("click", function (e) {
    if (e.target.closest(".mobile-toggle-btn")) {
      const btn = e.target.closest(".mobile-toggle-btn");
      const submenu = btn.parentElement.nextElementSibling;

      btn.classList.toggle("open");

      if (submenu) {
        submenu.classList.toggle("open");
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("productForm");
  const variantContainer = form?.querySelector(".block-radio");

  if (!variantContainer) return;

  const labels = Array.from(variantContainer.querySelectorAll("label"));

  const variants = [];
  const scents = new Set();

  for (let index = 0; index < labels.length; index++) {
    const label = labels[index];
    const input = label.querySelector('input[type="radio"]');
    if (!input) return;

    const parts = label.textContent.split("/").map((p) => p.trim());
    const [scent, size] = parts;
    if (!size) return;

    input.id = `o-${index}`;
    label.textContent = size;
    label.prepend(input);

    input.dataset.scent = scent;
    input.dataset.size = size;

    variants.push({ input, label, scent, size });
    scents.add(scent);
  }

  const scentContainer = document.querySelector(".scent-options");
  if (!scentContainer) return;

  document.querySelector("#productForm").classList.add("run");

  scents.forEach((scent) => {
    const label = document.createElement("label");
    const radio = document.createElement("input");
    radio.type = "radio";
    radio.name = "scent";
    radio.value = scent;
    label.append(radio, scent);
    scentContainer.appendChild(label);
  });

  function filterSizes(selectedScent) {
    let firstVisible = null;

    variants.forEach((v) => {
      const isMatch = v.input.dataset.scent === selectedScent;
      v.label.style.display = isMatch ? "flex" : "none";

      if (isMatch && !firstVisible) {
        firstVisible = v.input;
      }
    });

    if (firstVisible) {
      firstVisible.checked = true;
      firstVisible.click();
    }
  }

  scentContainer.querySelectorAll('input[name="scent"]').forEach((radio) => {
    radio.addEventListener("change", () => {
      filterSizes(radio.value);
    });
  });

  const firstScent = scentContainer.querySelector('input[name="scent"]');
  if (firstScent) {
    firstScent.checked = true;
    filterSizes(firstScent.value);
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("productForm");
  if (!form) return;

  form.addEventListener("submit", (e) => e.preventDefault());

  const addButton = form.querySelector('button[type="submit"]');
  addButton.addEventListener("click", async (e) => {
    e.preventDefault();

    addButton.disabled = true;

    const variantIdInput =
      form.querySelector('input[name="id"]:checked') ||
      form.querySelector('input[name="id"]');

    const variantId = variantIdInput?.value;

    const qtyInput = form.querySelector('[name="quantity"]');
    const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ id: variantId, quantity }),
      });

      if (!res.ok) throw await res.text();

      addButton.querySelector("span").textContent = "Added!";
      setTimeout(() => {
        addButton.querySelector("span").textContent =
          addButton.dataset.addToCartText;
        addButton.disabled = false;
      }, 1500);

      const cart = await fetch("/cart.js").then((r) => r.json());
      document.querySelector(".cart-count").textContent = cart.item_count;
    } catch (err) {
      addButton.disabled = false;
    }
  });
});
